export const localeOptions = [
  {
    title: 'English',
    value: 'en'
  },
  {
    title: '日本語',
    value: 'ja'
  }
]
